/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import idx from 'idx';

import AdminUpgradeReviewQuoteForm from 'admin/components/AdminUpgradeReviewQuoteForm';
import AdminUpgradePlanDefinitionForm from 'admin/components/AdminUpgradePlanDefinitionForm';
import AdminUpgradeRequestInvoiceForm from 'admin/components/AdminUpgradeRequestInvoiceForm';
import AdminUpgradePaymentForm from 'admin/components/AdminUpgradePaymentForm';

export const PAGE_INDEX_TO_TRACKING_PREFIX = [
  // $FlowIssue
  AdminUpgradePlanDefinitionForm.trackingPrefix, // $FlowIssue
  AdminUpgradeReviewQuoteForm.trackingPrefix, // $FlowIssue
  AdminUpgradeRequestInvoiceForm.trackingPrefix,
];

type Props = {
  canUseCreditCardInSelfServe: boolean,
  onSelectSchool?: () => void,
  organizationUuid: ?string,
  pageIndex: number,
};

class AdminUpgradeForms extends React.Component<Props> {
  render() {
    const { canUseCreditCardInSelfServe, onSelectSchool, organizationUuid } = this.props;

    switch (this.props.pageIndex) {
      case 0:
        return (
          <AdminUpgradePlanDefinitionForm
            organizationUuid={organizationUuid}
            onSelectSchool={onSelectSchool}
          />
        );
      case 1:
        return <AdminUpgradeReviewQuoteForm />;
      case 2:
        // TODO: pull this out once cc in ss released to all
        return canUseCreditCardInSelfServe ? (
          <AdminUpgradePaymentForm />
        ) : (
          <AdminUpgradeRequestInvoiceForm />
        );
      default:
        return <div>error</div>;
    }
  }
}

function mapStateToProps(state) {
  return {
    pageIndex: state.adminUpgradePage.pageIndex,
  };
}

const withOrganization = graphql(
  gql`
    query AdminUpgradeForms {
      settings {
        permissions {
          canUseCreditCardInSelfServe
        }
      }
    }
  `,
  {
    props: ({ data }) => ({
      canUseCreditCardInSelfServe: idx(
        data,
        _ => _.settings.permissions.canUseCreditCardInSelfServe
      ),
    }),
  }
);

export { AdminUpgradeForms };
// $FlowFixMe
export default connect(mapStateToProps)(withOrganization(AdminUpgradeForms));
